module.exports = __webpack_public_path__ + "assets/img/20_968_big.bbc4e3d1.jpg";